export default "__VITE_ASSET__CgexEj5U__"